import { createSlice,PayloadAction} from '@reduxjs/toolkit'

/**
 * Estado de UI del modulo Catalogos.
 *
 * Controla modos de agregar/editar, foco, busqueda e inputs condicionales como
 * `ext5`, que afecta validaciones visibles en la administracion de opciones.
 */
export const catalogosSlice = createSlice({
  name: 'catalogosOpciones',
  initialState: { 
    asignarFocus:false,
    isModoEditar:false, 
    isModoCambiarOpcionEditar:false, 
    isModoCambiarOpcionAgregar: false,
    InputBusquedaVacio: true,
    isExt5: false,
    inputActivado: false,
  },
  reducers: {
      establecerFocus: (state, action: PayloadAction<boolean>) => ({
        ...state,
        asignarFocus: action.payload,
      }),
      cambiarModoAgregarEditar: (state, action: PayloadAction<boolean>) => ({
          ...state,
          isModoEditar: action.payload,
        }),
      cambiarOpcionEditar: (state, action: PayloadAction<boolean>) => ({
          ...state,
          isModoCambiarOpcionEditar: action.payload,
        }),
      cambiarOpcionAgregar: (state, action: PayloadAction<boolean>) => ({
          ...state,
          isModoCambiarOpcionAgregar: action.payload,
        }),
        limpiarInputBusqueda: (state, action: PayloadAction<boolean>) => ({
            ...state,
            InputBusquedaVacio: action.payload,
          }),
        activarExt5: (state, action: PayloadAction<boolean>) => ({
            ...state,
            isExt5: action.payload,
          }), 
        activarInput: (state, action: PayloadAction<boolean>) => ({
            ...state,
            inputActivado: action.payload,
          }), 
    },
})

export const { 
  cambiarModoAgregarEditar, 
  establecerFocus, 
  cambiarOpcionEditar,
  cambiarOpcionAgregar,
  limpiarInputBusqueda,
  activarExt5,
  activarInput
  } = catalogosSlice.actions

export default catalogosSlice.reducer
